import { FacebookIcon, InstagramIcon, TikTokIcon, XIcon } from "./icons";

interface SocialLinkProps {
  href: string;
  icon: React.ReactNode;
}

function SocialLink({ href, icon }: SocialLinkProps) {
  return (
    <a
      className="drop-shadow-white transition-[filter] hover:drop-shadow-0-0-10"
      href={href}
      rel="noopener noreferrer"
      target="_blank"
    >
      {icon}
    </a>
  );
}

interface SocialsProps {
  facebookUrl?: string;
  instagramUrl?: string;
  tiktokUrl?: string;
  twitterUrl?: string;
}

export default function Socials({
  facebookUrl,
  instagramUrl,
  tiktokUrl,
  twitterUrl,
}: SocialsProps) {
  return (
    <ul className="flex items-center gap-2.5 md:ml-2.5">
      {!!instagramUrl && (
        <li>
          <SocialLink href={instagramUrl} icon={<InstagramIcon />} />
        </li>
      )}
      {!!twitterUrl && (
        <li>
          <SocialLink href={twitterUrl} icon={<XIcon />} />
        </li>
      )}
      {!!facebookUrl && (
        <li>
          <SocialLink href={facebookUrl} icon={<FacebookIcon />} />
        </li>
      )}
      {!!tiktokUrl && (
        <li>
          <SocialLink href={tiktokUrl} icon={<TikTokIcon />} />
        </li>
      )}
    </ul>
  );
}
